package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class SignSymptomType(private val literal: String) : IEnumType {
	单项("单项"),
	集合("集合");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "sign_symptom_type"}
	override fun getLiteral(): String {return literal}
}
